import { c as _c } from "react/compiler-runtime";
import InsertPhotoRoundedIcon from '@mui/icons-material/InsertPhotoRounded';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import NextLink from 'next/link';
import { ReactElement } from 'react';
import { useHits } from 'react-instantsearch';
export interface ResourceItemProps {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  link: string;
}
interface ResourceCardProps {
  item?: ResourceItemProps;
  priority?: boolean;
}
export function ResourceCard(t0) {
  const $ = _c(39);
  const {
    item,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? true : t1;
  const {
    hits,
    sendEvent
  } = useHits();
  let t2;
  if ($[0] !== hits || $[1] !== item?.id) {
    let t3;
    if ($[3] !== item?.id) {
      t3 = hit => hit.objectID === item?.id;
      $[3] = item?.id;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = hits.filter(t3);
    $[0] = hits;
    $[1] = item?.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hit_0 = t2;
  const theme = useTheme();
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function getImageUrl(imageUrl) {
      if (imageUrl == null) {
        return null;
      }
      try {
        const url = new URL(imageUrl);
        return url.origin + url.pathname;
      } catch {
        return null;
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getImageUrl = t3;
  const imageUrl_0 = getImageUrl(item?.imageUrl);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      xs: 210,
      md: 260,
      xl: 320
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      transition: _temp2
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      border: "none",
      backgroundColor: "transparent",
      cursor: "pointer",
      width: t4,
      borderRadius: 2,
      boxShadow: "none",
      p: 2,
      transition: _temp,
      "& .MuiImageBackground-root": t5,
      "&:hover": {
        backgroundColor: _temp3,
        "& .MuiImageBackground-root": {
          transform: "scale(1.05)"
        },
        "& .hoverImageEffects": {
          opacity: 0.3
        }
      },
      "&:focus-visible": {
        outline: "2px solid",
        outlineColor: _temp4
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = item?.link ?? "";
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      height: "inherit",
      color: "inherit",
      textDecoration: "none"
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== hit_0 || $[11] !== sendEvent) {
    t9 = event => {
      event.stopPropagation();
      sendEvent("click", hit_0, "Resource Clicked");
    };
    $[10] = hit_0;
    $[11] = sendEvent;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      maxHeight: 160,
      aspectRatio: 2,
      overflow: "hidden",
      borderRadius: 2,
      backgroundColor: "background.default"
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== imageUrl_0 || $[15] !== item?.title || $[16] !== priority || $[17] !== theme) {
    t11 = <Stack sx={t10}>{imageUrl_0 != null ? <Image rel={priority ? "preload" : undefined} priority={priority} className="MuiImageBackground-root" sizes={`(max-width: ${theme.breakpoints.values.md - 0.5}px) 130px, (max-width: ${theme.breakpoints.values.xl - 0.5}px) 180px, 280px`} src={imageUrl_0} alt={item?.title ?? ""} fill={true} style={{
        objectFit: "cover"
      }} /> : <InsertPhotoRoundedIcon className="MuiImageBackground-root" />}</Stack>;
    $[14] = imageUrl_0;
    $[15] = item?.title;
    $[16] = priority;
    $[17] = theme;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      px: 0,
      py: 3
    };
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = item?.title ?? "";
  let t14;
  if ($[20] !== t13) {
    t14 = <Typography variant="subtitle2">{t13}</Typography>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      display: {
        xs: "none",
        md: "-webkit-box"
      },
      height: 86,
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 3
    };
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      py: 1
    };
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = item?.description ?? "";
  let t18;
  if ($[24] !== t17) {
    t18 = <Box sx={t15}><Typography variant="body1" sx={t16}>{t17}</Typography></Box>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      display: {
        xs: "-webkit-box",
        md: "none"
      },
      height: "63px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 3
    };
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      py: 1
    };
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  const t21 = item?.description ?? "";
  let t22;
  if ($[28] !== t21) {
    t22 = <Box sx={t19}><Typography variant="body2" sx={t20}>{t21}</Typography></Box>;
    $[28] = t21;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== t14 || $[31] !== t18 || $[32] !== t22) {
    t23 = <Stack sx={t12}>{t14}{t18}{t22}</Stack>;
    $[30] = t14;
    $[31] = t18;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== t11 || $[35] !== t23 || $[36] !== t7 || $[37] !== t9) {
    t24 = <Card data-testid="ResourceCard" aria-label="ResourceCard" tabIndex={0} sx={t6}><Box component={NextLink} href={t7} tabIndex={-1} data-testid="ResourceCardLink" sx={t8} onClick={t9} locale={false}>{t11}{t23}</Box></Card>;
    $[34] = t11;
    $[35] = t23;
    $[36] = t7;
    $[37] = t9;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  return t24;
}
function _temp4(theme_3) {
  return theme_3.palette.primary.main;
}
function _temp3(theme_2) {
  return theme_2.palette.grey[200];
}
function _temp2(theme_1) {
  return theme_1.transitions.create("transform");
}
function _temp(theme_0) {
  return theme_0.transitions.create("background-color");
}